export default "/images/vendor/flag-icons/flags/1x1/mg.svg?bdd56d44e50a82caecc6b33d9452650a";